var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartsData)?_c('div',{staticClass:"finance-tab"},[_c('div',{staticClass:"body-text-1"},[_vm._v(_vm._s(_vm.subtitle))]),_vm._l((_vm.chartsData),function(chart){return _c('ja-pie-chart',{key:chart.title,staticClass:"chart",attrs:{"data":chart,"legend":"column"}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }